<script setup lang="ts">
import { computed } from 'vue'
import { FILE_TYPE_META } from '@/constants/documents'
import { useDateTime } from '@ai/ui-components'
import { formatFileSize } from '@/utils/number'
import { ODocumentPreviewModal } from '@ai/ui-components'

const props = defineProps<{
  id: string | number | null
  documentName: string
  type: string
  size?: string
  createdAt?: string
  lastUpdated?: string
  owner?: string
  blob: Blob | null
}>()

const emit = defineEmits<{ delete: []; import: []; download: [] }>()

const open = defineModel<boolean>('open', { default: false })

const { formatDateTime } = useDateTime()

const documentInfo = computed(() => {
  const typeMeta = FILE_TYPE_META[props.type]
  return {
    fileType: typeMeta.label,
    fileTypeIcon: typeMeta.icon,
    size: props.size ? formatFileSize(props.size) : undefined,
    createdAt: props.createdAt
      ? formatDateTime({ format: 'dateTime', value: props.createdAt })
      : undefined,
    lastUpdated: props.lastUpdated
      ? formatDateTime({ format: 'dateTime', value: props.lastUpdated })
      : undefined,
    owner: props.owner,
  }
})
</script>

<template>
  <div data-testid="preview-modal">
    <ODocumentPreviewModal
      :open="open"
      :title="documentName"
      :info="documentInfo"
      :blob="blob ?? undefined"
      :mime-type="type"
      :toolbar-actions="{
        edit: { show: false },
        import: { show: false },
        download: {},
      }"
      teleport
      @update:open="open = $event"
      @delete="emit('delete')"
      @import="emit('import')"
      @download="emit('download')"
    />
  </div>
</template>
